export const iconFontAwesomeHumanitarianRoadCircleCheck = (
	<i className="fa-solid fa-road-circle-check"></i>
);
